// src/components/roles/Table/RolesTableColumns.jsx
const RolesTableColumns = [
    { id: 'name', labelAr: 'الاسم', labelEn: 'Name' },
    // { id: 'actions', labelAr: 'الإجراءات', labelEn: 'Actions' },

];

export default RolesTableColumns;
